import React from 'react'
import * as Notifications from 'fw/globals/Notifications'
import { Col, Row, Button, Modal } from 'react-bootstrap'
import { TextBox, RichTextEditor } from 'fw/forms'
import { Label } from 'fw/components'
import * as API from 'modules/app/API'
import { DenialReasonCombo } from 'areas/shared/controls'

class FinalDenialEmailDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: props.visible,
            to: props.to,
            subject: props.subject,
            message: props.message
        };
    }

    componentWillReceiveProps(props, nextProps) {
        this.setState(
            {
                visible: props.visible,
                to: props.to,
                subject: props.subject,
                message: props.message
            });
    }

    close = () => {
        this.setState({ visible: false });
        if(this.props.onClose)
            this.props.onClose();
    }

    handleTextEditorChange = (e) => {
        this.setState({ message: e });
    }

    send = () => {
        let rq = {
            recipients: this.state.to,
            body: this.state.message,
            entityId: this.props.entityId,
            certificationId: this.props.certificationId,
            rowVersion: this.props.rowVersion
        }

        if(this.props.onSend){
            this.props.onSend(rq);
            this.close();
        }
        else{
            API.Admin.post('/finalReview/denyCertification', rq, {
                success: (r) => {
                    this.close();
    
                    Notifications.success(r.message);
                },
                error: (r) => {
                    Notifications.error(r.error.errorMessage);
                }
            });
        }
    }

    getDenialReasonEmail = (e) => {
        let rq = {
            denialReasonId: e.value,
            certificationId: this.props.certificationId
        };
        API.Admin.post('/finalReview/getDenialReason', rq,
            {
                success: (r) => {
                    this.setState({
                        message: r.data.emailText
                    }, () => {
                        this._emailBody.setValue(r.data.emailText);
                    });
                }
            });
    }


    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}>
                <Modal.Body>
                    <Row>
                        <Col md={2}><Label>To:</Label></Col>
                        <Col md={7}><TextBox value={this.state.to} readonly /></Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md={2}><Label>Subject:</Label></Col>
                        <Col md={7}><TextBox value={this.state.subject} readonly /></Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md={2}><Label>Template:</Label></Col>
                        <Col md={7}>
                            <DenialReasonCombo name='denialReasonId'
                                onChange={this.getDenialReasonEmail}
                                formControl={false} 
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md={12}>
                            <RichTextEditor 
                            enabled={true}
                            onChange={this.handleTextEditorChange} 
                            value={this.state.message} 
                            ref={(c) => { this._emailBody = c; }} />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.close}>Cancel</Button>
                    <Button bsStyle="primary" onClick={this.send}>Save and Send Email</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default FinalDenialEmailDialog;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/FinalDenialEmailDialog.js